module.exports = __webpack_public_path__ + "img/U8.c4152d09.png";